import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, InputLabel, TextField } from "@mui/material";
import { mediaManagerApi } from "../../../../../shell/services/mediaManager";
interface Props {
  open: boolean;
  onClose: () => void;
  name: string;
  id: string;
  groupId?: string;
}
export const RenameFolderDialog = ({
  open,
  onClose,
  name,
  id,
  groupId
}: Props) => {
  const {
    t
  } = useTranslation();
  const [newName, setNewName] = useState(name);
  const [updateGroup, {
    isLoading: updateGroupIsLoading,
    isSuccess: updateGroupIsSuccess
  }] = mediaManagerApi.useUpdateGroupMutation();
  const [updateBin, {
    isLoading: updateBinIsLoading,
    isSuccess: updateBinIsSuccess
  }] = mediaManagerApi.useUpdateBinMutation();
  const isLoading = updateGroupIsLoading || updateBinIsLoading;
  const isSuccess = updateGroupIsSuccess || updateBinIsSuccess;
  useEffect(() => {
    setNewName(name);
  }, [name]);
  useEffect(() => {
    if (isSuccess) onClose();
  }, [isSuccess]);
  const handleUpdate = () => {
    if (groupId) {
      updateGroup({
        id,
        body: {
          name: newName,
          group_id: groupId
        }
      });
    } else {
      updateBin({
        id,
        body: {
          name: newName
        }
      });
    }
  };
  return <Dialog open={open} onClose={onClose} fullWidth maxWidth={"xs"} data-sentry-element="Dialog" data-sentry-component="RenameFolderDialog" data-sentry-source-file="RenameFolderDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="RenameFolderDialog.tsx">{t("media.renameFolderDialogTitle")}</DialogTitle>
      <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="RenameFolderDialog.tsx">
        <InputLabel data-sentry-element="InputLabel" data-sentry-source-file="RenameFolderDialog.tsx">
          {t("media.renameFolderDialogNewFolderNameLabel")}
        </InputLabel>
        <TextField autoFocus onFocus={evt => evt.target.select()} value={newName} hiddenLabel size="small" fullWidth onChange={evt => setNewName(evt.target.value)} onKeyPress={event => event.key === "Enter" && handleUpdate()} data-sentry-element="TextField" data-sentry-source-file="RenameFolderDialog.tsx" />
      </DialogContent>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="RenameFolderDialog.tsx">
        <Button onClick={onClose} color="inherit" data-sentry-element="Button" data-sentry-source-file="RenameFolderDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button disabled={isLoading} variant="contained" onClick={handleUpdate} data-sentry-element="Button" data-sentry-source-file="RenameFolderDialog.tsx">
          {t("common.update")}
        </Button>
      </DialogActions>
    </Dialog>;
};